import React from 'react';
import Loadable from 'Shared/Loadable';

const LazyUpsellingV2 = props => (
  <Loadable
    module={() =>
      import(/* webpackChunkName: "upselling-v2" */ './UpsellingV2')
    }
    {...props}
  />
);

export default LazyUpsellingV2;
